import config from 'config';
import { Utilities, type App } from 'core/domains';
import { getLocationPathname } from 'core/utilities';

import { isMobile } from '../helpers';

export const initialState: App = {
  hasTouch: false,
  i18n: {
    country: 'BR',
    currency: 'BRL',
    locale: 'pt',
  },
  isCartActive: false,
  isDrawerActive: false,
  isMobile: isMobile(),
  isMobileMenuActive: false,
  isModalActive: false,
  isOverlayVisible: false,
  isProductNotFoundShippingActive: false,
  isScrollLocked: false,
  isSearchActive: false,
  isShippingActive: false,
  isPointsProgramActive: false,
  canLoadVWO: false,
  loader: {
    isLoading: false,
    message: '',
  },
  location: {
    current: getLocationPathname(),
    previous: '',
  },
  notifications: [],
  status: Utilities.STATUS.IDLE,
  version: config.app.version,
};
